import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotuljapurcabs() {



  const cardData =
  {
    keyword: 'Pune to Tuljapur Cab',
    heading: 'Sai Trupti Cabs: Pune to Tuljapur Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Tuljapur cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Tuljapur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Tuljapur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Tuljapur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Tulja Bhavani Temple",
    "description": "The Tulja Bhavani Temple is the crown jewel of Tuljapur and one of Maharashtra’s most revered Shakti Peethas. Dedicated to Goddess Bhavani, an incarnation of Durga, the temple was built in the 12th century by the Yadava rulers. The stone structure, adorned with intricate carvings, houses the eight-armed idol of the goddess standing over Mahishasura, symbolising the triumph of good over evil. Devotees believe Chhatrapati Shivaji Maharaj received his sword, the Bhavani Talwar, here — a legend deeply rooted in Maratha history. Pilgrims gather from across India, especially during Navratri and Dasara, when the temple glows with lamps and chants of 'Jai Tulja Bhavani' echo through the hills. The spiritual energy, sacred rituals, and centuries-old faith make this temple the beating heart of Tuljapur."
  },
  {
    "title": "Anandrao Nimbalkar Palace",
    "description": "The Anandrao Nimbalkar Palace stands near the main temple complex, offering a glimpse into Tuljapur’s royal past. Once home to the Nimbalkar family, who ruled the region under the Marathas, the palace reflects a unique fusion of Maratha and Deccan architectural styles. With its arched corridors, stone courtyards, and intricately carved doors, it serves as a living museum of Tuljapur’s heritage. Visitors can see relics of devotion, armour, and royal correspondence that connect faith and governance in one continuum. Standing within the palace walls, one feels transported to the age when Tulja Bhavani’s blessings guided kings and warriors alike. The site adds a regal dimension to the town’s spiritual identity."
  },
  {
    "title": "Paapnash Tirtha (Holy Tank)",
    "description": "Located near the Tulja Bhavani Temple, the Paapnash Tirtha is a sacred bathing tank believed to cleanse devotees of sins and misfortunes. The serene waters, surrounded by stone ghats and ancient shrines, reflect the temple’s golden spire and the sky above. Pilgrims take a ritual dip before entering the temple, following centuries-old tradition. The gentle sound of flowing water and ringing bells creates a peaceful rhythm of devotion. At dawn and dusk, the light dancing on the surface gives the place a surreal beauty. Paapnash Tirtha isn’t just water — it’s faith made tangible, offering purity and peace before divine darshan."
  },
  {
    "title": "Ghatshila Temple and Caves",
    "description": "Ghatshila, located about 4 km from Tuljapur, is a lesser-known yet enchanting site where mythology meets nature. According to legend, Goddess Bhavani appeared here to bless her devotees in ancient times. The site features small caves, shrines carved into the hillside, and a peaceful natural stream flowing through rocky terrain. During monsoon, waterfalls cascade around the caves, turning Ghatshila into a mystical landscape of green and stone. Devotees and nature lovers visit to meditate, picnic, and reconnect with the divine in solitude. Ghatshila reflects Tuljapur’s quieter side — a place where time slows and faith whispers through the wind."
  },
  {
    "title": "Vishnupad Temple",
    "description": "The Vishnupad Temple, located near the sacred tank in Tuljapur, is believed to mark the spot where Lord Vishnu’s footprint was imprinted during his earthly visits. The small yet powerful shrine is frequented by devotees seeking blessings for prosperity and stability in life. The temple’s tranquil atmosphere, ancient carvings, and steady flow of worshippers create an aura of divine continuity. The soft fragrance of flowers and incense fills the air as priests chant Vedic hymns. This spiritual gem adds to Tuljapur’s reputation as a sacred town where multiple deities reside in harmony."
  },
  {
    "title": "Akkalkot Swami Samarth Temple (Nearby)",
    "description": "Located about 75 km from Tuljapur, the Akkalkot Temple dedicated to Swami Samarth Maharaj is a spiritual extension of the region’s sacred geography. Devotees often visit both Tulja Bhavani and Akkalkot in a single pilgrimage circuit. The temple’s peaceful courtyard, sacred neem tree, and devotional chants create a meditative environment for visitors. Pilgrims believe that Swami Samarth’s presence here still guides the faithful, blessing them with wisdom and strength. The route from Tuljapur to Akkalkot passes through picturesque villages and farmlands, offering a serene journey of devotion and discovery."
  },
  {
    "title": "Dhakte Tuljabhavani Temple",
    "description": "Dhakte Tuljabhavani Temple, also known as the Small Bhavani Temple, is another revered shrine situated within Tuljapur. It is believed that the goddess resides here in her more approachable form, offering blessings of peace and maternal protection. The temple’s architecture resembles the main Tulja Bhavani shrine, with simpler carvings and a quieter environment. Many devotees visit Dhakte Bhavani first before proceeding to the main temple as part of the pilgrimage ritual. The temple radiates calm, devotion, and familiarity — a beautiful complement to the grandeur of the main shrine."
  },
  {
    "title": "Balaji Temple, Tuljapur",
    "description": "The Balaji Temple in Tuljapur is dedicated to Lord Venkateshwara and offers devotees a serene alternative to the crowded temple routes. Built with modern yet traditional Dravidian-inspired architecture, the temple complex features gopurams, carved pillars, and open courtyards that welcome both pilgrims and tourists. Surrounded by greenery and well-maintained paths, it provides a calm spiritual experience. The daily aarti, temple music, and prasad distribution reflect Tuljapur’s tradition of hospitality and faith. The Balaji Temple complements Tulja Bhavani’s energy with divine balance and grace."
  },
  {
    "title": "Pandharpur (Nearby Pilgrimage Circuit)",
    "description": "Only about 90 km from Tuljapur lies the holy town of Pandharpur, the seat of Lord Vitthal and Rukmini. Many devotees combine Tuljapur Darshan with a visit to Pandharpur as part of the revered Shakti-Vitthal circuit. The road between the two towns is scenic, passing through villages, sugarcane fields, and rural temples that reflect Maharashtra’s devotional culture. In Pandharpur, the banks of the Bhima River fill with songs and prayers as pilgrims queue for hours to touch the feet of Lord Vitthal. Together, Tuljapur and Pandharpur complete a journey of faith, endurance, and divine grace."
  },
  {
    "title": "Osmanabad Fort and City Tour",
    "description": "A short drive from Tuljapur, Osmanabad city offers heritage attractions like the Osmanabad Fort and ancient Jain temples carved from rock. The fort’s massive stone walls, arched gateways, and panoramic views tell stories of Deccan dynasties that once ruled the region. The city also features old markets selling brassware, traditional fabrics, and temple souvenirs. A visit to Osmanabad complements Tuljapur’s spiritual journey with a touch of history and culture. It’s an ideal day trip for travelers seeking a balanced mix of devotion and discovery."
  }
],



"services": [
  {
    "name": "Pune to Tuljapur Cab",
    "description": "Book comfortable Pune to Tuljapur cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Tuljapur Taxi Service",
    "description": "Hire a Pune to Tuljapur taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Tuljapur Car Hire",
    "description": "Rent a car from Pune to Tuljapur for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Tuljapur",
    "description": "Travel comfortably with AC cab service from Pune to Tuljapur. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Tuljapur",
    "description": "Affordable non-AC cab service from Pune to Tuljapur for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Tuljapur",
    "description": "Book spacious and comfortable Innova cabs from Pune to Tuljapur. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Tuljapur",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Tuljapur. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Tuljapur",
    "description": "Travel in style with luxury cab services from Pune to Tuljapur. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Tuljapur",
    "description": "Get pocket-friendly Pune to Tuljapur cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Tuljapur Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Tuljapur ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Tuljapur One Way Cab",
    "description": "Book one-way cabs from Pune to Tuljapur at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Tuljapur without return plans."
  },
  {
    "name": "Pune to Tuljapur Drop Cab",
    "description": "One-way drop cab service from Pune to Tuljapur with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Tuljapur",
    "description": "Premium corporate cab hire from Pune to Tuljapur with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Tuljapur",
    "description": "Elegant wedding cab service from Pune to Tuljapur with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Tuljapur",
    "description": "Book your Pune to Tuljapur cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Tuljapur Cab", "Pune to Tuljapur Taxi Service"],
  ["Pune to Tuljapur Car Hire", "AC Cab Pune to Tuljapur"],
  ["Non AC Cab Pune to Tuljapur", "Innova Cab Pune to Tuljapur"],
  ["Ertiga Cab Pune to Tuljapur", "Luxury Cab Pune to Tuljapur"],
  ["Affordable Cab Pune to Tuljapur", "Pune to Tuljapur Outstation Cab"],
  ["Pune to Tuljapur One Way Cab", "Pune to Tuljapur Drop Cab"],
  ["Online Cab Booking Pune to Tuljapur", "Corporate Cab Pune to Tuljapur"],
  ["Wedding Cab Pune to Tuljapur", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Tuljapur Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and reliable cab services from Pune to Tuljapur — ideal for temple visits, family travel, and leisure journeys in Maharashtra."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Tuljapur cabs — no hidden charges, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Tuljapur route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Tuljapur route, ensuring a safe, smooth, and timely travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, home, office, or railway station — and drop-offs at your desired location in Tuljapur."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains a fleet of clean, sanitized, and regularly serviced vehicles to provide a comfortable and reliable journey every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to assist you with bookings, route details, or travel queries for your Pune to Tuljapur cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Tuljapur cab easily via call, WhatsApp, or our website — get instant confirmation and enjoy a smooth, stress-free journey."
  }
]































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Tuljapur cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Tuljapur cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Tuljapur cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Tuljapur cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Tuljapur?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Tuljapur routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Tuljapur route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Tuljapur?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Tuljapur for attractions like Tulja Bhavani Temple, Renuka Devi Temple, and nearby historical sites.',
  },
  {
    question: 'Is the Pune to Tuljapur cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Tuljapur cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Tuljapur cab fares?',
    answer: 'Our Pune to Tuljapur cab fares start from ₹2,000 for sedans and ₹2,800–₹3,500 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Tuljapur cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Tuljapur cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Tuljapur cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Tuljapur trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Dinesh Shinde',
    feedback: 'Our Pune to Tuljapur journey with Sai Trupti Cabs was smooth and comfortable. The driver was courteous and the vehicle was well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Aarti Patil',
    feedback: 'Excellent service from Sai Trupti Cabs for Pune to Tuljapur. On-time pickup, clean car, and a very professional driver.',
    rating: 5,
  },
];





























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];



















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Tuljapur Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-tuljapur-cab.jpg", // Replace with actual image URL
  "description": "Book cabs from Pune to Tuljapur with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2700", // Example price, adjust according to actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-tuljapur-cab-booking"
  }
};


  return (
    <div>
<Helmet>
  <title>Pune to Tuljapur Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Tuljapur with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Pune to Tuljapur Cab, Pune to Tuljapur Taxi Service, Pune to Tuljapur Car Hire, AC Cab Pune to Tuljapur, Non AC Cab Pune to Tuljapur, Innova Cab Pune to Tuljapur, Ertiga Cab Pune to Tuljapur, Luxury Cab Pune to Tuljapur, Affordable Cab Pune to Tuljapur, Pune to Tuljapur Outstation Cab, Pune to Tuljapur One Way Cab, Pune to Tuljapur Drop Cab, Corporate Cab Pune to Tuljapur, Wedding Cab Pune to Tuljapur, Online Cab Booking Pune to Tuljapur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetotuljapurcabs;